import base from './base'

let controller = 'guaranteeTemplate'
let action = null

const GuaranteeTemplate = {
  async listGuaranteeTemplates (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListTemplates'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async listAvaliableGuaranteeTemplates (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListAvaliableTemplates'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addGuaranteeTemplate (request) {
    let model = {
      type: request.type || null,
      name: request.name || null,
      template: request.template || null,
      guarantorId: request.guarantorId || null,
      variety: request.variety || null,
      industryId: request.industryId || null,
      cityId: request.cityId || null,
      isPrivate: request.isPrivate || false
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateGuaranteeTemplate (request) {
    let model = {
      id: request.id || request.tid || null,
      type: request.type || null,
      name: request.name || null,
      template: request.template || null,
      guarantorId: request.guarantorId || null,
      variety: request.variety || null,
      industryId: request.industryId || null,
      cityId: request.cityId || null,
      isPrivate: request.isPrivate || false
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async auditPassGuaranteeTemplate (tId) {
    if (!tId) {
      throw new Error('TemplateId为空')
    }
    action = `AuditPass/${tId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async auditDenyGuaranteeTemplate (tId) {
    if (!tId) {
      throw new Error('TemplateId为空')
    }
    action = `AuditDeny/${tId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async deleteGuaranteeTemplate (tId) {
    if (!tId) {
      throw new Error('TemplateId为空')
    }
    action = `Delete/${tId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getGuaranteeTemplateDetail (templateId) {
    action = `Detail/${templateId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default GuaranteeTemplate